const password_rejected = {
    too_short: 'Độ dài tối thiểu là {{min}}.',
    too_long: 'Độ dài tối đa là {{max}}.',
    character_types: 'Cần ít nhất {{min}} loại ký tự.',
    unsupported_characters: 'Tìm thấy ký tự không được hỗ trợ.',
    pwned: 'Tránh sử dụng mật khẩu đơn giản dễ đoán.',
    restricted_found: 'Tránh lạm dụng {{list, list}}.',
    restricted: {
        repetition: 'ký tự lặp lại',
        sequence: 'ký tự liên tiếp',
        user_info: 'thông tin cá nhân của bạn',
        words: 'ngữ cảnh sản phẩm',
    },
};
export default Object.freeze(password_rejected);
